<template>
    <div class="container mt-5">
        <Calendar :events="eventsData" :title="orderTitle" @month-change="fetchDataForMonth"></Calendar>
    </div>
    
</template>

<script>
import Calendar from '@/components/Mymodule/Calendar.vue'

export default {
    data(){
        return{
            orderTitle: '訂餐紀錄',
            eventsData: [],
        }
    },
    components: {
        Calendar
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async fetchDataForMonth(month) {
        console.log("選擇的月份:", month);
        await this.GetCustomerOrderLog(month); 
    },

        async init() {
            await this.GetCustomerOrderLog();
        },
        async GetCustomerOrderLog(selectedMonth = null) { 
            if (!selectedMonth) {
                const currentDate = new Date();
                selectedMonth = `${currentDate.getFullYear()}/${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
            }

            var post_data = {
                searchData: this.$Global.Base64Utils.utoa(
                    JSON.stringify({
                        ShopNO: this.$Global.Base64Utils.atou(
                            this.$cookieFunc.getCookie("ShopNO")
                        ),
                        SuplNO: "20240912000001",
                        Homeid:this.$Global.Base64Utils.atou(
                            this.$cookieFunc.getCookie("Homeid")
                        ),
                        search:selectedMonth.replace("-", "/"), 
                        Userid:this.$Global.Base64Utils.atou(
                            this.$cookieFunc.getCookie("Userid")
                        ),
                    })
                ),
            };

            this.$axios({
                method: "post",
                url: this.$URLJson.GetCustomerOrderLog,
                data: post_data,
            })
                .then((res) => {
                    var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
                    this.eventsData = data;
                    console.log("訂餐紀錄:",this.eventsData);
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/View/Meal/MealOrderRecord.vue